<div [copoScroller]="{ restoreAfterViewInit: false }" #scroller="copoScroller" class="sidenav-content" @routeAnimation>
	<copo-panel-header class="step-title" [isBackButtonVisible]="true" (backButtonClick)="goBackOrOpenDialog()" [titleHeaderText]="pageTitle">
		<div *ngIf="isButtonSubmitVisible()" class="copo-wizard-action-button">
			<button class="next-button" type="button" mat-flat-button color="primary" [disabled]="isSaving" (click)="saveEcall()">
				<ng-container *ngIf="!isSaving">
					<span translate>ecall-off.submit-call-off</span>
				</ng-container>
				<copo-loading-spinner *ngIf="isSaving"></copo-loading-spinner>
			</button>
		</div>
		<ng-container *ngIf="selectedBatches.length > 0 && !hideNextBtn" class="copo-wizard-action-button">
			<button type="submit" mat-flat-button color="primary" *ngIf="selectedBatches.length > 0" (click)="goToNext()">
				<span translate>offers.action.next</span>
			</button>
		</ng-container>
	</copo-panel-header>
	<copo-stepper [steps]="steps" (stepClicked)="onStepClicked($event)" class="copo-stepper-container">
	</copo-stepper>
	<ng-template #loading>
		<copo-loading-spinner></copo-loading-spinner>
	</ng-template>
	<router-outlet *ngIf="!isLoading; else loading" copoAfterViewInit (afterviewinit)="scroller.restoreState()" (activate)="onActivate($event)">
	</router-outlet>
</div>